export default {
	editorConfig: {
		allowedContent: true,
		extraAllowedContent: '*(*);*{*}',
		extraPlugins: 'font',
		toolbar: [
			{ name: 'document', groups: ['mode', 'document', 'doctools'], items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
			{ name: 'clipboard', groups: ['clipboard', 'undo'], items: ['Cut', 'Copy', 'Paste', '-', 'Undo', 'Redo'] },
			//'/',
			{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'], items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
			{ name: 'paragraph', groups: ['list'], items: ['NumberedList', 'BulletedList'] },
			{ name: 'links', items: ['Link', 'Unlink'] },
			{ name: 'insert', items: ['Table', 'HorizontalRule', 'SpecialChar'] },
			//'/',
			{ name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
		]
	}
}